










import Vue from 'vue';
import { AxiosError, AxiosResponse } from 'axios';

import ProductAPI from '@/services/ProductAPI';
import ItemAPI from '@/services/ItemAPI';
import CharacterAPI from '@/services/CharacterAPI';
import UserAPI from '@/services/UserAPI';
import ShippingAPI from '@/services/ShippingAPI';
import PayingAPI from '@/services/PayingAPI';
import TagAPI from '@/services/TagAPI';
import SessionService from '@/services/SessionService';

import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Util from './util/Util';
import DataAPI from './services/DataAPI';

export default Vue.extend({
  name: 'App',

  components: {
    Navbar,
    Footer
  },

  created() {
    this.loadProducts();

    this.loadItems();

    this.loadCharacters();

    this.loadShippings();

    this.loadPayings();

    this.loadTags();

    this.authenticateSession();

    DataAPI.getCharacters()
      .then((axiosResponse: AxiosResponse) => this.$store.commit('setMostPopularCharacterTuples', axiosResponse.data));

    DataAPI.getItems()
      .then((axiosResponse: AxiosResponse) => this.$store.commit('setMostPopularItems', axiosResponse.data));

    Util.addMetaTagToHead(new Map<string, string>()
      .set('property', 'og:type')
      .set('content', 'website')
      .set('vue-controlled-meta-tag', ''));
    Util.addMetaTagToHead(new Map<string, string>()
      .set('property', 'fb:app_id')
      .set('content', process.env.VUE_APP_FACEBOOK_APP_ID)
      .set('vue-controlled-meta-tag', ''));
  },

  methods: {
    loadProducts(): void {
      ProductAPI
          .get()
          .then((axiosResponse: AxiosResponse) => this.$store.commit('setProducts', axiosResponse.data))
          .catch((error: AxiosError) => error);
    },

    loadItems(): void {
      ItemAPI
          .getItems()
          .then((axiosResponse: AxiosResponse) => this.$store.commit('setItems', axiosResponse.data))
          .catch((error: AxiosError) => error);
    },

    loadCharacters(): void {
      CharacterAPI
          .get()
          .then((axiosResponse: AxiosResponse) => this.$store.commit('setCharacters', axiosResponse.data))
          .catch((error: AxiosError) => error);
    },

    loadShippings(): void {
      ShippingAPI
          .get()
          .then((axiosResponse: AxiosResponse) => this.$store.commit('setShippings', axiosResponse.data))
          .catch((error: AxiosError) => error);
    },

    loadPayings(): void {
      PayingAPI
          .get()
          .then((axiosResponse: AxiosResponse) => this.$store.commit('setPayings', axiosResponse.data))
          .catch((error: AxiosError) => error);
    },

    loadTags(): void {
      TagAPI
          .getTags()
          .then((axiosResponse: AxiosResponse) => this.$store.commit('setTags', axiosResponse.data))
          .catch((error: AxiosError) => error);
    },

    authenticateSession(): void {
      const handleResponse = (response: AxiosResponse) => {
          if (response.data.sessionId) {
            SessionService.saveSession(response.data.sessionId, false);
          }
          if (response.data.user) {
            this.$store.commit('setUser', response.data.user);
          }
          if (response.data.order) {
            this.$store.commit('setOrder', response.data.order);
          }
        };

      const handleError = (error: AxiosError) => {
          if (error.response) {
            alert(error.response.data.message);
          }
        };

      UserAPI
        .authenticate()
        .then(handleResponse)
        .catch(handleError);
    }
  }

});
